export default [
  {
    text: 'Menu',
    icon: 'menu',
    visible: true,
    items: [
      {
        text: 'Gateway Overview',
        icon: 'globe',
        visible: true,
        path: '/gateways',
      },
      {
        text: 'Approve Adjustments',
        icon: 'check',
        visible: true,
        path: '/adjustment/approve',
      },
      {
        text: 'View statements',
        icon: 'file',
        visible: true,
        path: '/statements',
      },
      {
        text: 'Upload statement',
        path: '/statement/upload',
        icon: 'upload',
        visible: true,
      },
    ],
  },
]
